import entityReducers from './entities-reducers';

export default {
  ...entityReducers,
};

export * from './entities-slice';

export {default as saga} from './entities-sagas';
